function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00002 0.217285C4.61319 0.217285 3.48895 0.606452 3.48895 1.0865H8.51109C8.51109 0.606452 7.38685 0.217285 6.00002 0.217285Z",
  fill: "#64464B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.10432 2.92139H9.47673C9.58826 2.92139 9.67504 3.01514 9.66982 3.12655C9.64744 3.60391 9.54876 4.16555 9.36876 4.72016C9.343 4.79954 9.26759 4.85298 9.18412 4.85298H8.75034C8.94997 4.18095 9.06666 3.51057 9.10432 2.92139Z",
  fill: "#5073A5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.89571 2.92139H2.5233C2.41177 2.92139 2.32499 3.01514 2.33021 3.12655C2.35259 3.60391 2.45127 4.16555 2.63127 4.72016C2.65703 4.79954 2.73244 4.85298 2.81591 4.85298H3.24969C3.05006 4.18095 2.93337 3.51057 2.89571 2.92139Z",
  fill: "#5073A5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.63557 7.92218L8.08682 7.46666C7.87377 7.40401 7.71526 7.22507 7.67875 7.006L7.57179 6.36421C8.32958 5.66963 8.70426 4.5057 8.70426 3.50268C8.70426 1.95584 7.49354 1.37793 6.00003 1.37793C4.50653 1.37793 3.29581 1.95584 3.29581 3.50268C3.29581 4.5057 3.67049 5.66966 4.42827 6.36421L4.32131 7.006C4.2848 7.22507 4.12629 7.40401 3.91324 7.46666L2.36444 7.92218C1.54238 8.16394 0.977875 8.9184 0.977875 9.77527V11.4205C0.977875 11.7406 1.23731 12 1.55735 12H10.4427C10.7627 12 11.0221 11.7406 11.0221 11.4205V9.77527C11.0221 8.9184 10.4576 8.16394 9.63557 7.92218Z",
  fill: "#FAD7A5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.35594 1.37626C3.6202 0.761095 4.72382 0.386318 5.99999 0.386318C7.27617 0.386318 8.37976 0.761095 8.64405 1.37626H9.05251C8.82188 0.518825 7.56393 0 5.99999 0C4.43606 0 3.17811 0.518825 2.94748 1.37626H3.35594Z",
  fill: "#5073A5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.87526 7.69839L8.08681 7.4665C7.87376 7.40385 7.71525 7.22491 7.67874 7.00584L7.54526 6.20508L5.99999 6.78456L4.45472 6.20508L4.35648 6.7945C4.90531 7.76216 6.90881 8.90399 8.87526 7.69839Z",
  fill: "#F0C891"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.63557 7.92233C9.36332 7.84225 9.09055 8.04637 9.09055 8.33014V9.87541H2.90946V8.33014C2.90946 8.04634 2.6367 7.84225 2.36444 7.92233C1.54238 8.16412 0.977875 8.91855 0.977875 9.77543V11.4207C0.977875 11.7407 1.23731 12.0002 1.55735 12.0002H6.00001H10.4427C10.7627 12.0002 11.0221 11.7407 11.0221 11.4207V9.77543C11.0221 8.91855 10.4576 8.16412 9.63557 7.92233Z",
  fill: "#D2D7DC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.41449 0.98994C7.42286 0.98994 6.61708 0.441199 6.58277 0.0272113C6.39545 0.0100443 6.20099 0 6.00001 0C5.79902 0 5.60456 0.0100443 5.41724 0.0272113C5.38294 0.441199 4.57715 0.98994 3.58552 0.98994C3.53211 0.98994 3.50939 0.98994 3.48894 0.98994C3.45567 1.05264 3.48894 1.1166 3.48894 1.1831C3.48894 1.71648 4.6132 2.14889 6.00001 2.14889C7.38681 2.14889 8.51107 1.71648 8.51107 1.1831C8.51107 1.1166 8.54434 1.05264 8.51107 0.98994C8.47169 0.98994 8.46563 0.98994 8.41449 0.98994Z",
  fill: "#5F87B9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M8.70423 3.50268C8.70423 5.04952 7.81355 6.97954 6 6.97954C4.18646 6.97954 3.29578 5.04952 3.29578 3.50268C3.29578 1.95584 4.5065 1.37793 6 1.37793C7.49351 1.37793 8.70423 1.95584 8.70423 3.50268Z",
  fill: "#FFE1B4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M6 6.97956C5.38189 6.97956 4.8711 6.75523 4.46612 6.39844H3.93134C4.44888 6.98576 5.14908 7.36587 6 7.36587C6.85091 7.36587 7.55111 6.98576 8.06866 6.39844H7.53387C7.12889 6.75525 6.6181 6.97956 6 6.97956Z",
  fill: "#727887"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M9.00221 1.24022C8.94684 1.08884 8.80166 0.989746 8.64045 0.989746H6.00001H3.35958C3.19836 0.989746 3.05318 1.08884 2.99781 1.24022C2.88342 1.55305 2.71631 2.14322 2.71631 2.92134C2.71631 3.95551 3.11009 5.50522 3.97467 6.46375C4.05096 6.54835 4.15614 6.59136 4.26168 6.59136C4.3478 6.59136 4.43414 6.56274 4.50532 6.50477C4.67269 6.36843 4.68349 6.09757 4.5397 5.93652C3.95926 5.2864 3.6117 4.24389 3.51606 3.38419C3.48919 3.14272 3.68828 2.93667 3.93055 2.95531L5.55558 3.08031C5.85142 3.10307 6.1486 3.10307 6.44445 3.08031L8.06947 2.95531C8.31171 2.93667 8.51084 3.14272 8.48396 3.38419C8.38833 4.24392 8.04076 5.2864 7.46032 5.93652C7.31653 6.09754 7.32733 6.36843 7.4947 6.50477C7.56588 6.56274 7.65224 6.59136 7.73834 6.59136C7.84388 6.59136 7.94906 6.54835 8.02535 6.46375C8.88993 5.50522 9.28371 3.95551 9.28371 2.92134C9.28371 2.14322 9.11661 1.55305 9.00221 1.24022Z",
  fill: "#5F87B9"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M8.64875 7.39282L8.40785 8.35642C8.24147 9.02195 7.6435 9.48881 6.95749 9.48881H5.04252C4.35651 9.48881 3.75854 9.02192 3.59216 8.35642L3.35126 7.39282C3.31918 7.26451 3.19956 7.17778 3.06763 7.18723L0.793985 7.34962C0.697574 7.35651 0.639071 7.45915 0.682315 7.54561C0.743546 7.66805 0.855457 7.75721 0.988061 7.79116C3.06831 8.32372 2.90946 11.9999 2.90946 11.9999H6H9.09055C9.09055 11.9999 8.9317 8.32372 11.0119 7.79116C11.1446 7.75721 11.2565 7.66805 11.3177 7.54561C11.3609 7.45915 11.3024 7.35651 11.206 7.34962L8.93237 7.18723C8.80045 7.17781 8.68083 7.26451 8.64875 7.39282Z",
  fill: "#E6EBF0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M9.1261 11.0342H2.87393C2.92652 11.5944 2.90947 12 2.90947 12H6.00002H9.09056C9.09056 12 9.07351 11.5944 9.1261 11.0342Z",
  fill: "#5F87B9"
});

var SvgMma = function SvgMma(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mma.f78bf722.svg";
export { ForwardRef as ReactComponent };